import React from 'react';
import { Button, Form, Segment } from 'semantic-ui-react';


export default class Filters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            courseName: '',
            courseCode: ''
        };

        this.onFilterData = this.onFilterData.bind(this);
    }


    onFilterData() {
        this.props.onFilterData(this.state.courseName, this.state.courseCode);
    }


    render() {
        return (
            <Segment clearing>
                <Form>
                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>Naziv predmeta</label>
                            <input
                                value={this.state.courseName}
                                onChange={(e) => this.setState({ courseName: e.target.value })}
                                courseName="courseName"
                                placeholder="Unesite naziv predmeta"

                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Šifra predmeta</label>
                            <input
                                value={this.state.courseCode}
                                onChange={(e) => this.setState({ courseCode: e.target.value })}
                                courseName="courseCode"
                                placeholder="Unesite šifru predmeta"

                            />
                        </Form.Field>
                    </Form.Group>
                    <Button color="blue" onClick={this.onFilterData}>Filtriraj
                    </Button>
                    <Button basic="true" color="blue" onClick={this.props.filtersOff}>Odustani
                    </Button>
                </Form>
            </Segment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/Exams/Filters.js